import { createFileRoute } from "@tanstack/react-router";
import { CapitalCalls } from "@/components/CapitalCalls";

function RouteComponent() {
  return <CapitalCalls />;
}

export const Route = createFileRoute("/_authenticated/capital-calls/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
